import axios from "axios";
import Config from "../../config";

/**
 * Pede um print (kind: 'image') ou gravação de tela (kind: 'video') ao visitante
 * do webchat. O visitante ainda precisa aceitar o convite dentro do widget — a
 * captura nunca acontece sem ação dele.
 */
const actionSolicitarMidia = (chatId, data) =>
    axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat/${chatId}/midia/solicitar`,
        data,
    });

export default actionSolicitarMidia;
